import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import DeliveryDeleteButton from './DeliveryDeleteButton';
import DeliveryStartButton from './DeliveryStartButton';
import DeliveryItemsConfirmReturnButton from './resource/DeliveryItemsConfirmReturnButton';
import {
  CARGO_ITEM_STATUS,
  DELIVERY_STATUS,
  YANDEX_BUSINESS_NUMBER,
} from '../../../../config/constants';
import DeliveryCarrierRemissionGuideButton from './DeliveryCarrierRemissionGuideButton';
import YangoCheckClaimButton from './yango/YangoCheckClaimButton';
import YangoCancelationClaimButton from './yango/YangoCancelationClaimButton';

const DeliveryToolbar = ({
  deliveryId,
  deliveryStatus,
  items,
  remissionGuideList,
  businessTaxId,
}) => {
  const backToAgencyItems = items.filter(
    (item) => item.cargoItemStatus === CARGO_ITEM_STATUS.BACK_TO_AGENCY.value,
  );
  return (
    <ButtonToolbar className="pull-right">
      {deliveryStatus === DELIVERY_STATUS.REGISTERED.value && (
        <div>
          <DeliveryStartButton
            deliveryId={deliveryId}
            businessTaxId={businessTaxId}
          />{' '}
          <DeliveryDeleteButton deliveryId={deliveryId} />{' '}
          <DeliveryCarrierRemissionGuideButton
            remissionGuideList={remissionGuideList}
            deliveryId={deliveryId}
          />
        </div>
      )}
      {deliveryStatus === DELIVERY_STATUS.IN_TRANSIT.value &&
        businessTaxId === YANDEX_BUSINESS_NUMBER && (
          <div>
            <YangoCheckClaimButton deliveryId={deliveryId} />{' '}
            <YangoCancelationClaimButton deliveryId={deliveryId} />
          </div>
        )}
      {backToAgencyItems.length > 0 && (
        <DeliveryItemsConfirmReturnButton
          items={backToAgencyItems}
          deliveryId={deliveryId}
        />
      )}
    </ButtonToolbar>
  );
};

DeliveryToolbar.propTypes = {
  items: PropTypes.instanceOf(Array).isRequired,
  deliveryId: PropTypes.number.isRequired,
  deliveryStatus: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  remissionGuideList: PropTypes.arrayOf(PropTypes.object).isRequired,
  businessTaxId: PropTypes.string.isRequired,
};

export default DeliveryToolbar;
